import React from 'react';
import OTPInput, { ResendOTP } from 'otp-input-react';
import { useState } from 'react';

const VerifyForm = () => {
    const [OTP, setOTP] = useState('');
    const renderButton = (buttonProps) => {
      return <button className='theme-btn d-block' {...buttonProps}>Resend</button>;
    };
    const renderTime = (remainingTime) => {
      return <span className='d-block w-100'>{remainingTime} seconds remaining</span>;
    };
    
    return (
        <div className="p-5 form_container mx-auto">
            <div className="heading mb-3 text-center">
                <h3>Verify Your Account</h3>
                <p></p>
            </div>
            <OTPInput value={OTP} onChange={setOTP} autoFocus OTPLength={5} otpType="number" disabled={false} secure className="justify-content-around" placeholder="-----" inputClassName="form-control shadow-none mx-0"/>
            <ResendOTP renderButton={renderButton} renderTime={renderTime} className="mt-3 w-100 d-block"/>
            
        </div>
    );
};

export default VerifyForm;
